import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

export const store = new Vuex.Store({
  state: {
    msgsuccessStatus: false,
    msgerrorStatus: false,
    s3URL: "https://airbuddyimage.s3.us-east-2.amazonaws.com/",
    successMSG: "",
    errorMSG: "",
    logedUser: {
      fname: "",
      uname: "",
      email: "",
      image: "",
      airbuddyRate: "",
      requestRate: ""
    }
  },
  actions: {},
  mutations: {}
});
